import React from 'react';
import { Pagination, Table } from '@roo/roo';
import { useHistory } from 'react-router';
import { Column } from '@roo/roo/Table';
import { IListProps, MessageItem, NOTICE_TYPES, getMessageList } from './api';
import { getMessage } from '../MessageContent/api';

const { useState, useEffect, useCallback } = React;

const columns: Column<MessageItem>[] = [
    {
        prop: 'title',
        label: '消息标题',
        render: (text: string, row) => `【${row.mainTitle}】${row.title}`,
    },
    {
        prop: 'pubdate',
        label: '时间',
    },
];

const PAGE_SIZE = 20;

const getRowClass = (index: number, row: MessageItem) =>
    `table-row ${row.readSign ? 'table-unread' : ''}`;

const Index = (props: IListProps) => {
    const { msgType } = props;

    const [total, setTotal] = useState<number>(0);
    const [tableData, setTabelData] = useState<MessageItem[]>([]);
    const history = useHistory();
    const fetchMsgList = useCallback((pageNum = 1) => {
        getMessageList({
            pageNum,
            pageSize: PAGE_SIZE,
            msgType,
        }).then(res => {
            const { messageList, total } = res.data;
            setTotal(total);
            setTabelData(messageList);
        });
    }, []);

    useEffect(() => {
        fetchMsgList();
    }, []);

    return (
        <>
            <Table
                rowKey="id"
                border
                hover
                columns={columns}
                data={tableData}
                rowClassName={getRowClass}
                onRowClick={record => {
                    if (record.noticeType === NOTICE_TYPES.GOTO_RUL) {
                        getMessage(record.id).then(res => {
                            history.push(res.data.content);
                        });
                        return;
                    }
                    if (record.noticeType === NOTICE_TYPES.REFUND_REVIEW) {
                        getMessage(record.id).then(res => {
                            history.push(`/refundDetails?orderViewId=${res.data.content}`);
                        });
                        return;
                    }
                    if (record.noticeType === NOTICE_TYPES.THIRD_CANCEL) {
                        getMessage(record.id).then(res => {
                            history.push(
                                `./contract/cancel?id=${res.data.content}&msgId=${res.data.id}`,
                            );
                        });
                        return;
                    }
                    history.push(`./messageContent?id=${record.id}`);
                }}
            />
            <Pagination total={total} pageSize={PAGE_SIZE} onChange={fetchMsgList} />
        </>
    );
};

export default Index;
